import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../../../constants/actionTypes";
import { Icon, Grid } from "../../../../ecosystem/";
import { logUI } from "../../../../../api/andyliticsApi";
import * as Tools from "../../../../../helpers/Tools";
import { CareGapsError, CareGapsButtons, CareGapsHeading } from '../../../caregaps/components';
import Spinner from '../../../../common/spinner';
import CareGapYes from "../../components/summary/CareGapYes";
import CareGapDontNeed from "../../components/summary/CareGapDontNeed";
import * as procedureType from "../../../../../constants/textConstants";

class ColorectalCancerSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFailedToPost: false
        }
    }

    componentDidMount() {
        const { careGapsSessionId } = this.props;
        logUI("MBHWeb.UI.ColorectalCancerSummary.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
    }

    handleClick = (linkName) => {
        const { careGapFlowFormInputs, history, postCareGapFlowData, selectedNoCareGapReason, careGapsSessionId, selectedCareGapOption, careGapAttachments } = this.props;
        const payload = careGapFlowFormInputs ? { careGapSelectedOption: selectedCareGapOption, careGapAttachments, ...careGapFlowFormInputs } : { careGapSelectedOption: selectedCareGapOption, ...selectedNoCareGapReason };
        logUI(`MBHWeb.UI.ColorectalCancerSummary.${linkName}.Clicked`, new Date(), Tools.getURLPath(), { payload: payload, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
        this.setState({ isFailedToPost: false })
        //history.push('/schedulemyAnnualWellnessVisit/confirmation');
        {
            careGapFlowFormInputs ?
                postCareGapFlowData(careGapFlowFormInputs, procedureType.CrC)
                :
                postCareGapFlowData(selectedNoCareGapReason, procedureType.CrC)
        }
    }

    handleClickPrev = () => {
        const { history, selectedCareGapOption, careGapsSessionId } = this.props;
        logUI(`MBHWeb.UI.ColorectalCancerSummary.Previous.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        selectedCareGapOption === "Yes, I have had one" ? history.push('/schedulemyColorectalCancerscreening/confirmhistory') : history.push({ pathname: '/schedulemyColorectalCancerscreening/updatehistory', state: { prevClicked: true } })
    }


    componentWillUnMount() {
        const { clearFlowData, careGapsSessionId } = this.props;
        logUI(`MBHWeb.UI.ColorectalCancerSummary.ComponentUnMount`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        clearFlowData();
    }

    componentDidUpdate(prevProps, prevState) {
        // Comparing prevStates to updatedStates
        if (prevProps.postCareGapDataResult !== this.props.postCareGapDataResult) {
            if (this.props.postCareGapDataResult && this.props.postCareGapDataResult.success) {
                this.setState({ isFailedToPost: false })
                this.props.history.push('/schedulemyColorectalCancerscreening/confirmation');
            } else {
                this.setState({ isFailedToPost: true })
            }
        }
    }

    render() {
        const { careGapFlowFormInputs, selectedNoCareGapReason, postCareGapDataPending, selectedCareGapOption, careGapAttachments } = this.props;
        const { isFailedToPost } = this.state;
        const showTryAgainError = isFailedToPost && !postCareGapDataPending;
        const nextBtnLabel = showTryAgainError ? 'Try Again' : "Submit";
        return (
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-summary-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row confirmation-display">
                            <div className="col care-gaps-summary-container__icon">
                                <span >
                                    <Icon name="check" size="large" color={"$color-system-a1"} />
                                </span>
                            </div>
                            <div className="col care-gaps-summary-container__content">
                                <div className="row">
                                    <div className="col-12">
                                        <CareGapsHeading
                                            heading="You are almost done!"
                                            description="How does everything look?"
                                            className="care-gaps-summary-page-heading"
                                        />
                                    </div>
                                </div>

                                {postCareGapDataPending && <Spinner />}

                                <div className="row">
                                    <div className="col-lg-8">
                                        {showTryAgainError && <CareGapsError />}
                                    </div>
                                </div>

                                {careGapFlowFormInputs ?
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <CareGapYes
                                                careGapTitle="Date of Colorectal Cancer Screening"
                                                inputData={careGapFlowFormInputs}
                                                fileData={careGapAttachments}
                                                selectedCareGapOption={selectedCareGapOption}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <CareGapDontNeed
                                                careGapTitle="Reason"
                                                selectedNoCareGapReason={selectedNoCareGapReason}
                                                careGapDateTitle="Date of Colorectal Cancer Screening"
                                            />
                                        </div>
                                    </div>
                                }

                                <CareGapsButtons
                                    prev={{
                                        onClick: () => this.handleClickPrev(),
                                        hide: showTryAgainError
                                    }}
                                    next={{
                                        label: nextBtnLabel,
                                        onClick: () => this.handleClick(nextBtnLabel),
                                        icon: ""
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        postCareGapDataResult: state.careGap.postCareGapDataResult,
        careGapFlowFormInputs: state.careGap.careGapFlowFormInputs,
        postCareGapDataPending: state.careGap.postCareGapDataPending,
        selectedNoCareGapReason: state.careGap.selectedNoCareGapReason,
        selectedCareGapOption: state.careGap.selectedCareGapOption,
        careGapsSessionId: state.careGap.careGapsSessionId,
        careGapAttachments: state.inMemory.careGapAttachments
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        clearFlowData: () => {
            dispatch({ type: types.CLEAR_CAREGAP_DATA_AFTER_SUBMIT })
        },
        postCareGapFlowData: (careGapData, procedureType) => dispatch({ type: types.POST_CAREGAP_FLOW_DATA, careGapData, procedureType }),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorectalCancerSummary);